






import { Vue, Component, Prop } from 'vue-property-decorator'
import getAvatar from '@/utils/avatar'

@Component
export default class UserAvatar extends Vue {
  @Prop({ default: '' }) readonly nickname!: string
  @Prop({ default: '' }) readonly imageUrl!: string
  @Prop({ default: 96 }) readonly width!: number
  @Prop({ default: true }) readonly border!: boolean

  /* Computed Properties */
  get src() {
    return this.imageUrl ? this.imageUrl : getAvatar()
  }

  get cssRules() {
    return {
      '--border': this.border ? '1.5px solid white' : 'none'
    }
  }
}
